var _rect, _g, _g2, _path, _g3, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrown3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_283_18164",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_283_18164)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_283_18164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.2102 5.76874L30.3193 11.2895L22.8638 14.0131L23.9787 6.15356C24.0633 5.55778 24.8015 5.32709 25.2102 5.76874Z",
    fill: "url(#paint0_linear_283_18164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.44626 15.9491L15.5897 18.5872L9.90478 24.1265L7.51997 16.8414C7.33412 16.2736 7.88586 15.7422 8.44626 15.9491Z",
    fill: "url(#paint1_linear_283_18164)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_283_18164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.0754 18.5493L32.6053 3.38377C32.3712 2.83504 31.6074 2.79811 31.3215 3.3217L27.3826 10.5341C27.0842 11.0804 26.414 11.3027 25.8483 11.043L12.2853 4.81643C11.7949 4.59131 11.2416 4.97031 11.2743 5.50889L12.1385 19.7357C12.1808 20.4325 11.6146 21.0147 10.9168 20.9918L1.43659 20.68C0.820562 20.6597 0.469238 21.3739 0.865901 21.8456C4.13557 25.7344 9.41586 31.8808 11.9922 35.08C12.6906 35.9472 13.8151 36.3819 14.8975 36.121C27.8714 32.9932 35.844 25.4156 38.8796 21.0289C39.3842 20.2997 39.4234 19.365 39.0754 18.5493Z",
    fill: "url(#paint2_linear_283_18164)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_283_18164",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 40,
    height: 35
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.7994 17.902L32.6053 3.38329C32.3712 2.83455 31.6074 2.79762 31.3215 3.32121L27.3826 10.5336C27.0842 11.0799 26.414 11.3022 25.8483 11.0425L12.2853 4.81595C11.7949 4.59083 11.2416 4.96982 11.2743 5.5084L12.1385 19.7352C12.1808 20.432 11.6146 21.0142 10.9168 20.9913L1.43659 20.6795C0.820562 20.6592 0.469238 21.3734 0.865901 21.8452C3.90771 25.4629 8.68965 31.0346 11.4158 34.3695C12.4728 35.6625 14.1657 36.3205 15.7816 35.8985C27.6951 32.7878 35.2397 25.9419 38.4679 21.6017C39.2618 20.5343 39.3214 19.1255 38.7994 17.902Z",
    fill: "#D9D9D9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_283_18164)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_283_18164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.2012 1.26416C31.06 6.56579 29.4745 14.1114 24.8809 10.4513C26.0285 8.94382 30.3175 3.64924 32.2012 1.26416Z",
    fill: "url(#paint3_linear_283_18164)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_283_18164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.714844 20.7139C5.98744 21.9824 13.5184 24.1451 11.9753 18.5668C10.1194 18.9479 3.68058 20.0496 0.714844 20.7139Z",
    fill: "url(#paint4_linear_283_18164)"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6214 24.0554C26.5361 24.1129 26.4359 24.1482 26.3086 24.1587L24.3442 24.3415C24.2936 24.3432 24.2339 24.362 24.1771 24.4003C24.1274 24.4339 24.0806 24.487 24.0551 24.5258L23.1628 26.2818C23.1125 26.3912 23.0423 26.4709 22.9429 26.538C22.7725 26.6531 22.5541 26.6818 22.3505 26.6251C22.1469 26.5685 21.9843 26.4194 21.8927 26.2224L21.0497 24.376C20.9939 24.2627 20.8884 24.183 20.7673 24.1568L18.8319 23.7701C18.5586 23.7173 18.3418 23.5186 18.2628 23.2484C18.1838 22.9782 18.2563 22.7028 18.4515 22.5172L19.8772 21.1992C19.9666 21.1173 20.0139 20.9883 19.9965 20.8706L19.6866 18.88C19.646 18.6055 19.7599 18.3454 19.98 18.1968C20.2002 18.0482 20.484 18.04 20.7234 18.1803L22.4535 19.2124C22.5682 19.2751 22.6935 19.2769 22.8029 19.2246L24.5586 18.3955C24.8037 18.284 25.0862 18.3198 25.3022 18.4867C25.5233 18.661 25.6265 18.9364 25.5802 19.2049L25.2269 21.147C25.1988 21.2738 25.2404 21.3967 25.3246 21.4908L26.7094 22.9608C26.8579 23.1194 26.9352 23.326 26.9116 23.536C26.9001 23.7487 26.7918 23.9404 26.6214 24.0554Z",
    fill: "url(#paint5_linear_283_18164)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_283_18164",
    x: 7.48242,
    y: 5.53906,
    width: 22.8359,
    height: 18.5874,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.888682
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.94413 0 0 0 0 0.911784 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_283_18164"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_283_18164",
    x: 0.697266,
    y: 2.94971,
    width: 38.6055,
    height: 35.0239,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.36982
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.888682
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.956091 0 0 0 0 0.935742 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_283_18164"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_283_18164",
    x: 24.8809,
    y: 1.26416,
    width: 9.09768,
    height: 10.1533,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.77736
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.0368
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.978109 0 0 0 0 0.604021 0 0 0 0 0.41923 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_283_18164"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_283_18164",
    x: 0.714844,
    y: 18.5669,
    width: 13.2422,
    height: 3.64111,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.77736
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.0368
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.978109 0 0 0 0 0.604021 0 0 0 0 0.41923 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_283_18164"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_283_18164",
    x1: 15.3904,
    y1: 10.1992,
    x2: 19.4916,
    y2: 16.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#FBC6AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC7D45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_283_18164",
    x1: 15.3904,
    y1: 10.1992,
    x2: 19.4916,
    y2: 16.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#FBC6AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC7D45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_283_18164",
    x1: 35.8442,
    y1: 11.744,
    x2: 7.06943,
    y2: 29.5106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175343,
    stopColor: "#FFC8AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.322647,
    stopColor: "#FFAA80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665958,
    stopColor: "#FFDCCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986264,
    stopColor: "#FFAF86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_283_18164",
    x1: 29.3621,
    y1: 7.30234,
    x2: 26.6293,
    y2: 11.7936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC8AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB089"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_283_18164",
    x1: 7.28188,
    y1: 20.9964,
    x2: 12.3735,
    y2: 20.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC8AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB089"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_283_18164",
    x1: 19.9992,
    y1: 18.2144,
    x2: 24.9802,
    y2: 24.4442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E55D2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF815C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown3);
export default __webpack_public_path__ + "static/media/crown_3.6dcd190013c98765cefbbbef9303c121.svg";
export { ForwardRef as ReactComponent };